/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { LIVE_TV_SHAKA_PLAYER_ERROR_PRIORITY } from '../../../config';
import { ErrorTypes } from '../../error';
import { Locale } from '../../locale/Locale';
import { LocaleKeys } from '../../locale/LocaleKeys';
import { Log } from '../../logging';
import { LiveTvErrorBase } from './LiveTvErrorBase';

export class LiveTvPlaybackError extends LiveTvErrorBase {
    TAG: string = 'LiveTvPlaybackError';

    public processErrorByCode(error: any) {
        Log.d(this.TAG, 'process Playback Error', error);
        switch (error.getCode()) {
            case ErrorTypes.LIVE_TV_IN_BLACKLIST_OSD_ERROR_C138:
                this.description = Locale.getString(LocaleKeys.LIVE_TV_IN_BLACKLIST_OSD_MESSAGE);
                this.uiErrorCode = error.getCode();
                break;
            case ErrorTypes.LIVE_TV_DEVICE_ERROR_MISSING_CONFIG_V904:
                this.priority = LIVE_TV_SHAKA_PLAYER_ERROR_PRIORITY;
                this.title = Locale.getString(LocaleKeys.LIVE_TV_DEVICE_CONFIG_ERROR_TITLE);
                this.description = Locale.getString(LocaleKeys.LIVE_TV_DEVICE_CONFIG_ERROR_MESSAGE);
                this.uiErrorCode = error.getCode();
                break;

            case ErrorTypes.LIVE_TV_VPCONFIGURATIONS_EMPTY_RESPONSE_ERROR_V934:
            case ErrorTypes.LIVE_TV_VPCONFIGURATIONS_MISCONFIGURATION_ERROR_V909:
            case ErrorTypes.LIVE_TV_NOT_READY_FOR_PLAYBACK_V117:
            case ErrorTypes.LIVE_TV_PLAYLIST_URI_MISSING_V908:
                this.priority = LIVE_TV_SHAKA_PLAYER_ERROR_PRIORITY;
                this.title = Locale.getString(LocaleKeys.LIVE_TV_CANT_PLAY_TITLE);
                this.description = Locale.getString(LocaleKeys.LIVE_TV_UNABLE_TO_PLAY_MESSAGE);
                this.uiErrorCode = error.getCode();
                break;
            case ErrorTypes.LIVE_TV_SHAKA_PLAYER_ENFORCEMENT_ERROR_V948:
                this.priority = LIVE_TV_SHAKA_PLAYER_ERROR_PRIORITY;
                this.title = Locale.getString(LocaleKeys.LIVE_TV_PLAYER_ENFORCEMENT_ERROR_TITLE);
                this.description = Locale.getString(
                    LocaleKeys.LIVE_TV_PLAYER_ENFORCEMENT_ERROR_MESSAGE,
                );
                this.uiErrorCode = `${error.getCode()}-${error.getSubCode()}`;
                break;
            case ErrorTypes.LIVE_TV_SHAKA_PLAYER_NETWORK_ERROR_V951:
            case ErrorTypes.LIVE_TV_SHAKA_PLAYER_TEXT_ERROR_V952:
            case ErrorTypes.LIVE_TV_SHAKA_PLAYER_MEDIA_ERROR_V953:
            case ErrorTypes.LIVE_TV_SHAKA_PLAYER_MANIFEST_ERROR_V954:
            case ErrorTypes.LIVE_TV_SHAKA_PLAYER_STREAMING_MEDIA_V955:
            case ErrorTypes.LIVE_TV_SHAKA_PLAYER_DRM_ERROR_V956:
            case ErrorTypes.LIVE_TV_SHAKA_PLAYER_PLAYER_ERROR_V957:
            case ErrorTypes.LIVE_TV_SHAKA_PLAYER_CAST_ERROR_V958:
            case ErrorTypes.LIVE_TV_SHAKA_PLAYER_STORAGE_ERROR_V959:
            case ErrorTypes.LIVE_TV_SHAKA_PLAYER_ADS_ERROR_V960:
                this.priority = LIVE_TV_SHAKA_PLAYER_ERROR_PRIORITY;
                this.title = Locale.getString(LocaleKeys.LIVE_TV_PLAYER_ERROR_TITLE);
                this.description = Locale.getString(LocaleKeys.LIVE_TV_UNABLE_TO_PLAY_MESSAGE);
                this.uiErrorCode = `${error.getCode()}-${error.getSubCode()}`;
                break;

            case ErrorTypes.LIVE_TV_GRACE_PERIOD_ENDED_ERROR_C718:
                this.priority = LIVE_TV_SHAKA_PLAYER_ERROR_PRIORITY;
                this.title = Locale.getString(LocaleKeys.LIVE_TV_GRACE_PERIOD_ENDED_ERROR_TITLE);
                this.description = Locale.getString(
                    LocaleKeys.LIVE_TV_GRACE_PERIOD_ENDED_ERROR_MESSAGE,
                );
                this.uiErrorCode = error.getCode();
                break;
            case ErrorTypes.LIVE_TV_AIRING_DATA_FAILED_V139:
                this.priority = LIVE_TV_SHAKA_PLAYER_ERROR_PRIORITY;
                this.title = Locale.getString(LocaleKeys.LIVE_TV_CANT_PLAY_TITLE);
                this.description = Locale.getString(LocaleKeys.LIVE_TV_CANT_PLAY_MESSAGE);
                this.uiErrorCode = error.getCode();
                break;
            default:
                this.priority = LIVE_TV_SHAKA_PLAYER_ERROR_PRIORITY;
                this.title = Locale.getString(LocaleKeys.LIVE_TV_PLAYER_ERROR_TITLE);
                this.description = Locale.getString(LocaleKeys.LIVE_TV_UNABLE_TO_PLAY_MESSAGE);
                this.uiErrorCode = ErrorTypes.LIVE_TV_SHAKA_PLAYER_UNKNOWN_ERROR_V999;
                break;
        }
    }
}
